module.exports = "<div *ngIf=\"isLoading | async\" class=\"overlay\">\r\n  <span class=\"k-icon k-i-loading\" style=\"color: grey\"></span>\r\n</div>\r\n\r\n"